var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9229 17.8621C19.3235 15.6215 20.3905 11.8872 19.7503 8.31299H10.2012V12.2607H15.6426C15.4292 13.541 14.6823 14.6079 13.6154 15.3015L16.9229 17.8621Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.13184 14.7146C1.83362 16.097 2.84006 17.3021 4.07531 18.239C5.31055 19.1759 6.74237 19.8202 8.26281 20.1232C9.78326 20.4263 11.3527 20.3802 12.8527 19.9886C14.3528 19.5969 15.7444 18.8698 16.9226 17.8621L13.615 15.3014C10.7877 17.1686 6.09311 16.475 4.4927 12.1006L1.13184 14.7146Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4931 12.1006C4.06633 10.7669 4.06633 9.53997 4.4931 8.20629L1.13224 5.59229C-0.0947424 8.04625 -0.468172 11.5138 1.13224 14.7146L4.4931 12.1006Z",
    fill: "#FBBC02"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4927 8.20631C5.66633 4.52536 10.681 2.39148 14.0418 5.53895L16.9759 2.65821C12.8148 -1.34281 4.70609 -1.18277 1.13184 5.5923L4.4927 8.20631Z",
    fill: "#EA4335"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoogle);
export default __webpack_public_path__ + "static/media/icon-google.dc3c16a9e836983a630efbf210fb9238.svg";
export { ForwardRef as ReactComponent };